export default __webpack_public_path__ + "static/media/1.588cdc16.jpg";